import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import {
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import React, { useState } from "react";

let mySearchTimer: any;

interface Props {
  data: any;
  SetSearch: React.Dispatch<React.SetStateAction<string>>;
  dealerId: string;
  SetDealerId: React.Dispatch<React.SetStateAction<string>>;
  errorMessage: string;
  SetErrorMessage: React.Dispatch<React.SetStateAction<string>>;
  stackTrace: string;
  SetStackTrace: React.Dispatch<React.SetStateAction<string>>;
  env: string;
  SetEnv: React.Dispatch<React.SetStateAction<string>>;
  note: string;
  SetNote: React.Dispatch<React.SetStateAction<string>>;
  rowsPerPage: number;
  setRowsPerPage: React.Dispatch<React.SetStateAction<number>>;
  currentPageNumber: number;
  SetCurrentPageNuber: React.Dispatch<React.SetStateAction<number>>;
  rowsCount: number;
}

const DataTable = (props: Props) => {
  const {
    data,
    SetSearch,
    dealerId,
    SetDealerId,
    errorMessage,
    SetErrorMessage,
    stackTrace,
    SetStackTrace,
    env,
    SetEnv,
    note,
    SetNote,
    rowsPerPage,
    setRowsPerPage,
    currentPageNumber,
    SetCurrentPageNuber,
    rowsCount,
  } = props;

  const classes = useStyles();

  const [currentRow, SetCurrentRow] = useState([] as any);

  // ---------------------------- HANDLERS --------------------------------//

  function ApplyChanges() {
    clearTimeout(mySearchTimer);
    mySearchTimer = setTimeout(() => SetSearch(new Date().toString()), 100);
  }

  const handleChangePage = (event: any, newPage: any) => {
    SetCurrentPageNuber(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    SetCurrentPageNuber(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  //! ---------------------------- TablePaginationActions START--------------------------------//
  function TablePaginationActions(props: any) {
    const theme: any = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = (event: any) => {
      SetCurrentPageNuber(0);
    };

    const handleBackButtonClick = (event: any) => {
      SetCurrentPageNuber(page - 1);
    };

    const handleNextButtonClick = (event: any) => {
      SetCurrentPageNuber(page + 1);
    };

    const handleLastPageButtonClick = (event: any) => {
      SetCurrentPageNuber(Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <div className={classes.root}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRightIcon />
          ) : (
            <KeyboardArrowLeftIcon />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeftIcon />
          ) : (
            <KeyboardArrowRightIcon />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    );
  }
  //! ---------------------------- TablePaginationActions END --------------------------------//

  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  };

  return (
    <div style={{ margin: "10px" }}>
      <TableContainer component={Paper}>
        <Table className={classes.myTable}>
          <TableHead>
            <TableRow>
              <TableCell>ErrorDate</TableCell>
              <TableCell>DealerId</TableCell>
              <TableCell>ErrorMessage</TableCell>
              <TableCell>StackTrace</TableCell>
              <TableCell>Env</TableCell>
              <TableCell>Note</TableCell>
            </TableRow>
          </TableHead>

          <TableRow>
            <TableCell></TableCell>
            <TableCell>
              <input
                className={classes.myInput}
                type="text"
                style={{ width: "50px" }}
                value={dealerId}
                onChange={(e: any) => {
                  SetDealerId(e.target.value);
                  ApplyChanges();
                }}
              ></input>
            </TableCell>
            <TableCell>
              <input
                className={classes.myInput}
                type="text"
                style={{ width: "95%" }}
                value={errorMessage}
                onChange={(e: any) => {
                  SetErrorMessage(e.target.value);
                  ApplyChanges();
                }}
              ></input>
            </TableCell>
            <TableCell>
              <input
                className={classes.myInput}
                type="text"
                style={{ width: "95%" }}
                value={stackTrace}
                onChange={(e: any) => {
                  SetStackTrace(e.target.value);
                  ApplyChanges();
                }}
              ></input>
            </TableCell>
            <TableCell>
              <input
                className={classes.myInput}
                type="text"
                style={{ width: "50px" }}
                value={env}
                onChange={(e: any) => {
                  SetEnv(e.target.value);
                  ApplyChanges();
                }}
              ></input>
            </TableCell>
            <TableCell>
              <input
                className={classes.myInput}
                type="text"
                style={{ width: "100px" }}
                value={note}
                onChange={(e: any) => {
                  SetNote(e.target.value);
                  ApplyChanges();
                }}
              ></input>
            </TableCell>
          </TableRow>

          {data.map((row: any, index: any) => {
            return (
              <TableRow
                hover
                role="checkbox"
                onClick={(event) => {
                  SetCurrentRow(row);
                }}
                style={{
                  backgroundColor:
                    currentRow != null && currentRow.ErrorId == row.ErrorId
                      ? "#EAFAF1"
                      : "",
                }}
              >
                <TableCell>{row.ErrorDate}</TableCell>
                <TableCell>{row.DealerId}</TableCell>
                <TableCell valign="top">{row.ErrorMessage}</TableCell>
                <TableCell valign="top">
                  <Tooltip
                    arrow
                    title={row.StackTrace.length > 200 ? row.StackTrace : ""}
                    style={{ border: "0px solid red" }}
                  >
                    <span>
                      {row.StackTrace.length > 200 &&
                      currentRow.ErrorId != row.ErrorId
                        ? row.StackTrace.substring(0, 190) + "..."
                        : row.StackTrace}
                    </span>
                  </Tooltip>
                </TableCell>
                <TableCell>{row.Env}</TableCell>
                <TableCell>{row.Note}</TableCell>
              </TableRow>
            );
          })}
        </Table>

        <TablePagination
          rowsPerPageOptions={[15, 20, 50, 100]}
          component="div"
          count={rowsCount}
          rowsPerPage={rowsPerPage}
          page={currentPageNumber}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
        />
      </TableContainer>
    </div>
  );
};

export default DataTable;

DataTable.propTypes = {
  data: PropTypes.object.isRequired,
};

const useStyles = makeStyles((theme: any) => ({
  root: {
    flexShrink: 0,
  },
  hideCell: {
    display: "none !important",
  },
  myTable: {
    "& th": {
      padding: "5px 5px",
      backgroundColor: "#EAEDED",
      // , paddingLeft:"10px"
    },
    "& td": {
      borderBottom: "1px solid #EAEDED",
      //whiteSpace: "nowrap",
      height: "0px",
      padding: "3px 5px",
    },
    "& tr:nth-child(even)": { backgroundColor: "#FBFCFC" },
  },
  myInput: {
    border: "1px solid #BDC3C7",
    padding: "4px 7px",
    width: "100%",
    "&:focus": {
      border: "1px solid #5DADE2",
      outline: "none",
      color: "#5DADE2",
    },
  },
}));
